import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "red"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  class: "red"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  key: 2
};
const _hoisted_11 = {
  style: {
    "margin": "16px"
  }
};
const _hoisted_12 = {
  key: 3
};
const _hoisted_13 = {
  key: 0,
  class: "red"
};
const _hoisted_14 = {
  key: 1,
  class: "red"
};
const _hoisted_15 = {
  key: 2
};
const _hoisted_16 = {
  key: 3
};
const _hoisted_17 = {
  key: 4
};
const _hoisted_18 = {
  key: 5,
  class: "red"
};
const _hoisted_19 = {
  key: 6,
  class: "red"
};
const _hoisted_20 = {
  key: 7,
  class: "red"
};
const _hoisted_21 = {
  class: "red"
};
const _hoisted_22 = {
  key: 4
};
const _hoisted_23 = {
  key: 0
};
const _hoisted_24 = {
  class: "red"
};
const _hoisted_25 = {
  class: "red"
};
const _hoisted_26 = {
  class: "red"
};
const _hoisted_27 = {
  class: "red"
};
const _hoisted_28 = {
  class: "red"
};
const _hoisted_29 = {
  class: "red"
};
const _hoisted_30 = {
  class: "red"
};
const _hoisted_31 = {
  class: "red"
};
const _hoisted_32 = {
  class: "red"
};
const _hoisted_33 = {
  class: "red"
};
const _hoisted_34 = {
  class: "red"
};
const _hoisted_35 = {
  key: 0,
  style: {
    "color": "#ED3908",
    "font-size": "12px"
  }
};
const _hoisted_36 = {
  class: "red"
};
const _hoisted_37 = {
  class: "red"
};
const _hoisted_38 = {
  class: "red"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_uploader = _resolveComponent("van-uploader");
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_area = _resolveComponent("van-area");
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_van_form = _resolveComponent("van-form");
  const _component_BottomNav = _resolveComponent("BottomNav");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_nav_bar, {
    title: $data.title
  }, null, 8, ["title"]), $data.order == null ? (_openBlock(), _createBlock(_component_van_cell, {
    key: 0
  }, {
    default: _withCtx(() => _cache[9] || (_cache[9] = [_createElementVNode("p", null, "没有找到这个订单", -1)])),
    _: 1
  })) : $data.order.phoneNumber != null ? (_openBlock(), _createBlock(_component_van_cell, {
    key: 1
  }, {
    default: _withCtx(() => [$data.order.order.status == 20 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_cache[16] || (_cache[16] = _createElementVNode("h4", null, "付款", -1)), _createElementVNode("p", null, [_cache[10] || (_cache[10] = _createTextVNode(" 打开")), _cache[11] || (_cache[11] = _createElementVNode("span", {
      class: "red"
    }, "支付宝", -1)), _cache[12] || (_cache[12] = _createTextVNode("扫描下面二维码付款,请在")), _createElementVNode("span", _hoisted_3, _toDisplayString($data.leftTime), 1), _cache[13] || (_cache[13] = _createTextVNode("分钟内完成支付，否则订单将会关闭。 "))]), _createElementVNode("p", null, [_cache[14] || (_cache[14] = _createTextVNode("付款金额：")), _createElementVNode("span", null, _toDisplayString($data.order.tradeRecord.totalAmount), 1), _cache[15] || (_cache[15] = _createTextVNode("元"))]), _createElementVNode("p", null, [_createElementVNode("img", {
      width: "30%",
      src: $data.order.tradeRecord.qrcodeUrl
    }, null, 8, _hoisted_4)])])) : _createCommentVNode("", true), $data.order.order.status == 22 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_cache[25] || (_cache[25] = _createElementVNode("h4", null, "上传购卡人证件照片", -1)), _createElementVNode("p", null, [_cache[17] || (_cache[17] = _createTextVNode(" 根据国家对通信产品")), _cache[18] || (_cache[18] = _createElementVNode("span", {
      class: "red"
    }, "实名信息登记", -1)), _cache[19] || (_cache[19] = _createTextVNode("的要求，您需要为号码")), _createElementVNode("span", _hoisted_6, _toDisplayString($data.order.phoneNumber.phoneNumber), 1), _cache[20] || (_cache[20] = _createTextVNode("上传居民身份证正反面照片和正面免冠照片，我们将严格保障您的信息安全 "))]), _createElementVNode("p", null, [_createElementVNode("img", {
      width: "100%",
      src: $data.frontSrc
    }, null, 8, _hoisted_7), _createVNode(_component_van_uploader, {
      style: {
        "width": "100%"
      },
      "after-read": $options.readFront,
      "max-count": 1
    }, {
      default: _withCtx(() => [_createVNode(_component_van_button, {
        round: "",
        block: "",
        type: "info",
        "native-type": "submit"
      }, {
        default: _withCtx(() => _cache[21] || (_cache[21] = [_createTextVNode(" 上传身份证正面照片 ")])),
        _: 1
      })]),
      _: 1
    }, 8, ["after-read"])]), _createElementVNode("p", null, [_createElementVNode("img", {
      width: "100%",
      src: $data.backSrc
    }, null, 8, _hoisted_8), _createVNode(_component_van_uploader, {
      style: {
        "width": "100%"
      },
      "after-read": $options.readBack,
      "max-count": 1
    }, {
      default: _withCtx(() => [_createVNode(_component_van_button, {
        round: "",
        block: "",
        type: "info",
        "native-type": "submit"
      }, {
        default: _withCtx(() => _cache[22] || (_cache[22] = [_createTextVNode(" 上传身份证背面照片 ")])),
        _: 1
      })]),
      _: 1
    }, 8, ["after-read"])]), _createElementVNode("p", null, [_createElementVNode("img", {
      width: "100%",
      src: $data.nowrapSrc
    }, null, 8, _hoisted_9), _createVNode(_component_van_uploader, {
      style: {
        "width": "100%"
      },
      "after-read": $options.readNowrap,
      "max-count": 1
    }, {
      default: _withCtx(() => [_createVNode(_component_van_button, {
        round: "",
        block: "",
        type: "info",
        "native-type": "submit"
      }, {
        default: _withCtx(() => _cache[23] || (_cache[23] = [_createTextVNode(" 上传正面免冠照片 ")])),
        _: 1
      })]),
      _: 1
    }, 8, ["after-read"])]), _createVNode(_component_van_button, {
      round: "",
      block: "",
      type: "danger",
      "native-type": "submit",
      onClick: _cache[0] || (_cache[0] = $event => $options.doneOrder())
    }, {
      default: _withCtx(() => _cache[24] || (_cache[24] = [_createTextVNode(" 完 成 订 单 ")])),
      _: 1
    })])) : $data.order.order.status == 21 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_cache[27] || (_cache[27] = _createElementVNode("h4", null, "填写购卡人资料", -1)), _createElementVNode("p", null, [_createVNode(_component_van_form, {
      onSubmit: $options.submitInfo
    }, {
      default: _withCtx(() => [_createVNode(_component_van_field, {
        modelValue: $data.info.userName,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.info.userName = $event),
        modelModifiers: {
          trim: true
        },
        name: "姓名",
        label: "姓名",
        placeholder: "请输入购买人姓名",
        rules: [{
          required: true
        }]
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        modelValue: $data.info.phone,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.info.phone = $event),
        modelModifiers: {
          trim: true
        },
        name: "联系电话",
        label: "联系电话",
        placeholder: "请输入购买人联系电话",
        rules: [{
          pattern: $data.phonePattern,
          required: true,
          message: '请输入正确的联系电话'
        }]
      }, null, 8, ["modelValue", "rules"]), _createVNode(_component_van_field, {
        modelValue: $data.info.idCard,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.info.idCard = $event),
        modelModifiers: {
          trim: true
        },
        name: "身份证号",
        label: "身份证号",
        placeholder: "请输入购买人身份证号码",
        rules: [{
          validator: $options.checkIdcard,
          required: true,
          message: '请输入正确的身份证号码'
        }]
      }, null, 8, ["modelValue", "rules"]), _createVNode(_component_van_field, {
        readonly: "",
        clickable: "",
        name: "area",
        value: $data.value,
        label: "收件地址",
        placeholder: "点击选择省市区",
        rules: [{
          required: true
        }],
        onClick: _cache[4] || (_cache[4] = $event => $data.showArea = true)
      }, null, 8, ["value"]), _createVNode(_component_van_popup, {
        modelValue: $data.showArea,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.showArea = $event),
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_area, {
          "area-list": $data.areaList,
          onConfirm: $options.onConfirm,
          onCancel: _cache[5] || (_cache[5] = $event => $data.showArea = false)
        }, null, 8, ["area-list", "onConfirm"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_van_field, {
        modelValue: $data.info.address,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.info.address = $event),
        modelModifiers: {
          trim: true
        },
        name: "详细地址",
        label: "详细地址",
        placeholder: "请输入详细收货地址",
        rules: [{
          required: true
        }]
      }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_van_button, {
        round: "",
        block: "",
        type: "info",
        "native-type": "submit"
      }, {
        default: _withCtx(() => _cache[26] || (_cache[26] = [_createTextVNode(" 提 交 资 料 ")])),
        _: 1
      })])]),
      _: 1
    }, 8, ["onSubmit"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_12, [_cache[30] || (_cache[30] = _createElementVNode("h4", null, "订单信息", -1)), _createElementVNode("p", null, [_cache[28] || (_cache[28] = _createTextVNode("订单状态： ")), $data.order.order.status == 23 ? (_openBlock(), _createElementBlock("span", _hoisted_13, "待下单")) : $data.order.order.status == 24 ? (_openBlock(), _createElementBlock("span", _hoisted_14, "已下单")) : $data.order.order.status == 20 ? (_openBlock(), _createElementBlock("span", _hoisted_15, "未付款")) : $data.order.order.status == 21 ? (_openBlock(), _createElementBlock("span", _hoisted_16, "待填写资料")) : $data.order.order.status == 22 ? (_openBlock(), _createElementBlock("span", _hoisted_17, "待上传证件照")) : $data.order.order.status == -21 ? (_openBlock(), _createElementBlock("span", _hoisted_18, "超时关闭")) : $data.order.order.status == -20 ? (_openBlock(), _createElementBlock("span", _hoisted_19, "退单退款")) : $data.order.order.status == -11 ? (_openBlock(), _createElementBlock("span", _hoisted_20, "退单不退款")) : _createCommentVNode("", true)]), _createElementVNode("p", null, [_cache[29] || (_cache[29] = _createTextVNode("创建时间：")), _createElementVNode("span", _hoisted_21, _toDisplayString($data.order.order.createTime), 1)])])), $data.order.info != null ? (_openBlock(), _createElementBlock("div", _hoisted_22, [$data.order.info.expressComponey != null ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_cache[31] || (_cache[31] = _createElementVNode("h4", null, "物流信息", -1)), _createElementVNode("p", null, _toDisplayString($data.order.info.expressComponey) + " " + _toDisplayString($data.order.info.expressNo), 1)])) : _createCommentVNode("", true), _cache[36] || (_cache[36] = _createElementVNode("h4", null, "购卡人资料", -1)), _createElementVNode("p", null, [_cache[32] || (_cache[32] = _createTextVNode("姓名：")), _createElementVNode("span", _hoisted_24, _toDisplayString($data.order.info.userName), 1)]), _createElementVNode("p", null, [_cache[33] || (_cache[33] = _createTextVNode("联系电话：")), _createElementVNode("span", _hoisted_25, _toDisplayString($data.order.info.phone), 1)]), _createElementVNode("p", null, [_cache[34] || (_cache[34] = _createTextVNode("身份证号：")), _createElementVNode("span", _hoisted_26, _toDisplayString($data.order.info.idCard), 1)]), _createElementVNode("p", null, [_cache[35] || (_cache[35] = _createTextVNode("收件地址：")), _createElementVNode("span", _hoisted_27, _toDisplayString($data.order.info.province) + _toDisplayString($data.order.info.city) + _toDisplayString($data.order.info.area) + _toDisplayString($data.order.info.address), 1)])])) : _createCommentVNode("", true), _cache[51] || (_cache[51] = _createElementVNode("h4", null, "号码详情", -1)), _createElementVNode("p", null, [_cache[37] || (_cache[37] = _createTextVNode("号码：")), _createElementVNode("span", _hoisted_28, _toDisplayString($data.order.phoneNumber.phoneNumber), 1)]), _createElementVNode("p", null, [_cache[38] || (_cache[38] = _createTextVNode("运营商：")), _createElementVNode("span", _hoisted_29, _toDisplayString($data.order.phoneNumber.optName), 1)]), _createElementVNode("p", null, [_cache[39] || (_cache[39] = _createTextVNode("归属地：")), _createElementVNode("span", _hoisted_30, _toDisplayString($data.order.phoneNumber.province) + " " + _toDisplayString($data.order.order.area), 1)]), _createElementVNode("p", null, [_cache[40] || (_cache[40] = _createTextVNode("价格：")), _createElementVNode("span", _hoisted_31, _toDisplayString($data.order.phoneNumber.salePrice + $data.order.phoneNumber.fee), 1), _cache[41] || (_cache[41] = _createTextVNode("元 （服务费 ")), _createElementVNode("span", _hoisted_32, _toDisplayString($data.order.phoneNumber.salePrice), 1), _cache[42] || (_cache[42] = _createTextVNode(" 元 + 话费 ")), _createElementVNode("span", _hoisted_33, _toDisplayString($data.order.phoneNumber.fee), 1), _cache[43] || (_cache[43] = _createTextVNode(" 元） "))]), _createElementVNode("p", null, [_cache[44] || (_cache[44] = _createTextVNode("实际支付：")), _createElementVNode("span", _hoisted_34, _toDisplayString($data.order.order.price), 1), _cache[45] || (_cache[45] = _createTextVNode(" 元 ")), $data.order.order.discountAmount != null ? (_openBlock(), _createElementBlock("span", _hoisted_35, "（已优惠" + _toDisplayString($data.order.order.discountAmount) + "元）", 1)) : _createCommentVNode("", true)]), _createElementVNode("p", null, [_cache[46] || (_cache[46] = _createTextVNode("包含话费：")), _createElementVNode("span", _hoisted_36, _toDisplayString($data.order.phoneNumber.fee), 1), _cache[47] || (_cache[47] = _createTextVNode(" 元"))]), _createElementVNode("p", null, [_cache[48] || (_cache[48] = _createTextVNode("合约期：")), _createElementVNode("span", _hoisted_37, _toDisplayString($data.order.phoneNumber.onlineMonths), 1), _cache[49] || (_cache[49] = _createTextVNode(" 月"))]), _createElementVNode("p", null, [_cache[50] || (_cache[50] = _createTextVNode("介绍：")), _createElementVNode("span", _hoisted_38, _toDisplayString($data.order.phoneNumber.introduce), 1)]), _cache[52] || (_cache[52] = _createElementVNode("div", {
      style: {
        "height": "67px"
      }
    }, null, -1)), _createVNode(_component_BottomNav, {
      onChangeCartNum: _cache[8] || (_cache[8] = $event => _ctx.cartNum = $event)
    })]),
    _: 1
  })) : _createCommentVNode("", true)]);
}